var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54313 19.0708C9.17531 19.2296 8.76828 19.2743 8.37477 19.1991C7.98126 19.1238 7.61942 18.9321 7.33613 18.6488L3.09213 14.4058C2.13087 13.4442 1.43055 12.2535 1.05731 10.946C0.684075 9.63859 0.650231 8.25758 0.958978 6.93342C1.26772 5.60925 1.90887 4.38563 2.82188 3.37809C3.73489 2.37055 4.88964 1.61233 6.17708 1.17504C7.46452 0.737744 8.84217 0.635802 10.18 0.878837C11.5177 1.12187 12.7715 1.70186 13.8229 2.56405C14.8742 3.42623 15.6885 4.54216 16.1888 5.80645C16.6891 7.07075 16.8589 8.4417 16.6821 9.78984M12.7491 16.7488H18.7491M15.7491 13.7488V19.7488M5.74915 8.74884C5.74915 9.54449 6.06522 10.3076 6.62782 10.8702C7.19043 11.4328 7.9535 11.7488 8.74915 11.7488C9.54479 11.7488 10.3079 11.4328 10.8705 10.8702C11.4331 10.3076 11.7491 9.54449 11.7491 8.74884C11.7491 7.95319 11.4331 7.19013 10.8705 6.62752C10.3079 6.06491 9.54479 5.74884 8.74915 5.74884C7.9535 5.74884 7.19043 6.06491 6.62782 6.62752C6.06522 7.19013 5.74915 7.95319 5.74915 8.74884Z",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLocation);
export default __webpack_public_path__ + "static/media/add-location.010e23d311a019de63b18ba0f5cd97f0.svg";
export { ForwardRef as ReactComponent };